<template>
  <div>
    <a 
      href 
      class="inline-flex items-center underline" 
      :class="{
        'text-orange-500': value.length > 0 && value.length < 20,
        'text-green-500': value.length === 20,
        'text-red-500': value.length === 0
      }"
      @click.prevent="isOpen = !isOpen"
    >
      <div>{{ value.length }} ønsker registrert</div>
      <font-awesome-icon 
        class="ml-2"
        size="xs"
        :icon="['far', isOpen ? 'chevron-up' : 'chevron-down']" 
      />
    </a>
    <ol v-if="isOpen" class="mt-4 pl-6 list-decimal list-outside">
      <li 
        class=" cursor-default hover:bg-white"
        v-for="(wish, index) in value" :key="index">
        {{ wish.pharmacy }} <span class="text-xs">({{ wish.postCode }} {{ wish.postPlace }})</span>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  
  name: 'display-wish-list',

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      isOpen: false
    }
  }

}
</script>